var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5579 2C20.3563 2 20.3563 4.73474 18.5579 4.73474H8.73474V23.8021H18.5579C20.3563 23.8021 20.3563 26.5365 18.5579 26.5365H7.3672C6.61259 26.5365 6 25.9243 6 25.1697V3.3672C6 2.61225 6.61259 2 7.3672 2H18.5579ZM10.689 12.9009C8.89103 12.9009 8.89103 15.6353 10.689 15.6353H17.3008L15.7515 17.1843C14.4801 18.456 16.4137 20.3892 17.6851 19.1179L21.5604 15.2429C22.0826 14.7203 22.1264 13.8597 21.5604 13.2933L17.6851 9.41869C16.4137 8.1473 14.4801 10.0805 15.7515 11.3523L17.3008 12.9009H10.689Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.a806c1ceca60e7bd22a47e718616f54f.svg";
export { ForwardRef as ReactComponent };